const CardTypes = ({ type }) => {
	return (
		<p style={{ display: "flex" }}>
			<i
				className={
					type === "visa"
						? "fa fa-cc-visa fa-2x"
						: "fa fa-cc-visa fa-2x working"
				}
			/>
			<i
				className={
					type === "mastercard"
						? "fa fa-cc-mastercard fa-2x"
						: "fa fa-cc-mastercard fa-2x working"
				}
				style={{ paddingLeft: "7.5px", paddingRight: "7.5px" }}
			/>
			<i
				className={
					type === "amex"
						? "fa fa-cc-amex fa-2x"
						: "fa fa-cc-amex fa-2x working"
				}
				style={{ paddingRight: "7.5px" }}
			/>
			<i
				className={
					type === "discover"
						? "fa fa-cc-discover fa-2x"
						: "fa fa-cc-discover fa-2x working"
				}
				style={{ paddingRight: "7.5px" }}
			/>
		</p>
	);
};

export default CardTypes;
